export const cipOriginSchema: any = {
    id: "",
    originName: "",
    options: [],
    location: {},
    organizationId: "",
    createdBy: "",
  };
  